import React, { useState } from "react";
import { PageHeader, Btn } from "@/components/kit";
import { Zap, Copy, Check, ExternalLink, Code2, Link2 } from "lucide-react";
import { toast } from "sonner";

export default function QuoteWidget() {
  const origin = window.location.origin;
  const quoteUrl = `${origin}/quote`;
  const iframe = `<iframe src="${quoteUrl}" title="Instant Roof Quote" width="100%" height="760" style="border:0;border-radius:16px;overflow:hidden" loading="lazy"></iframe>`;
  const button = `<a href="${quoteUrl}" target="_blank" rel="noopener" style="display:inline-block;background:#C8102E;color:#fff;font-weight:700;padding:14px 28px;border-radius:12px;text-decoration:none;font-family:sans-serif">Get an Instant Roof Quote</a>`;
  const [copied, setCopied] = useState("");
  const copy = (key, text) => { navigator.clipboard.writeText(text); setCopied(key); toast.success("Copied to clipboard"); setTimeout(() => setCopied(""), 1500); };

  const Block = ({ id, label, icon: Icon, code }) => (
    <div className="mb-card p-5" data-testid={`widget-${id}`}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-display font-bold uppercase text-navy flex items-center gap-2"><Icon className="w-4 h-4" /> {label}</h3>
        <button onClick={() => copy(id, code)} data-testid={`copy-${id}`} className="flex items-center gap-1 text-sm font-semibold text-navy hover:text-brandred">
          {copied === id ? <Check className="w-4 h-4 text-successg" /> : <Copy className="w-4 h-4" />} {copied === id ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="bg-slate-900 text-slate-100 text-xs rounded-xl p-4 overflow-x-auto mb-scroll whitespace-pre-wrap break-all">{code}</pre>
    </div>
  );

  return (
    <div>
      <PageHeader title="Quote Widget" subtitle="Drop the instant-quote experience onto your own website — leads land straight in your CRM."
        actions={<a href={quoteUrl} target="_blank" rel="noopener" data-testid="open-quote-link"><Btn variant="red"><ExternalLink className="w-4 h-4" /> Open Live Page</Btn></a>} />

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="space-y-4">
          <Block id="link" label="Direct Link" icon={Link2} code={quoteUrl} />
          <Block id="iframe" label="Embed (iframe)" icon={Code2} code={iframe} />
          <Block id="button" label="Button Snippet" icon={Zap} code={button} />
          <p className="text-xs text-slate-400 px-1">Paste the iframe into any page (Wix, Squarespace, WordPress, custom HTML). Every submission creates a lead with source <b>InstaQuote</b> and a saved Good/Better/Best estimate.</p>
        </div>
        <div className="mb-card p-3" data-testid="widget-preview">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-400 mb-2 px-1">Live preview</div>
          <iframe src={quoteUrl} title="preview" className="w-full rounded-xl border border-slate-200" style={{ height: "70vh", minHeight: 500 }} />
        </div>
      </div>
    </div>
  );
}
